// Magic Boost Card - Organic Morphing Glow Effect

export function initMagicBoostGlow() {
    const card = document.querySelector('#magic-boost-card');
    if (!card) {
        console.log('Magic Boost card not found');
        return;
    }

    // Create the glow element - liquid glass effect
    const glowElement = document.createElement('div');
    glowElement.id = 'magic-boost-glow';
    glowElement.style.cssText = `
        position: absolute;
        width: 900px;
        height: 180px;
        background: radial-gradient(ellipse, #6428FF 0%, transparent 70%);
        filter: blur(0px);
        opacity: 1;
        pointer-events: none;
        z-index: -1;
        bottom: -90px;
        left: 50%;
        border-radius: 50%;
    `;

    card.appendChild(glowElement);
    console.log('Magic Boost glow element created');

    // Animation parameters
    let animationFrame;
    let time = 0;

    // Liquid glass movement - slow, smooth undulations like liquid in a container
    function animateGlow() {
        // Organic speed variation - speeds up and slows down naturally
        const speedVariation = 1 + Math.sin(time * 0.2) * 0.3; // Varies from 0.7x to 1.3x
        time += 0.008 * speedVariation;

        // Get card width for horizontal movement range
        const cardWidth = card.offsetWidth;

        // Horizontal sway - liquid shifting across full container width
        // Move from left edge to right edge (accounting for element's own width)
        const horizontalMove = Math.sin(time * 0.4) * (cardWidth * 0.5);

        // Calculate how close we are to the edges (0 = center, 1 = at edge)
        const edgeProximity = Math.abs(horizontalMove) / (cardWidth * 0.5);

        // Liquid "piles up" dramatically taller when hitting the side walls
        const edgeHeightBoost = edgeProximity * 0.8; // Up to 80% taller at edges

        // Very gentle vertical undulation - liquid slightly rising and falling
        const verticalMove = Math.sin(time * 0.8) * 15;

        // Direction of movement (-1 to 1, negative = moving left, positive = moving right)
        const movementDirection = Math.cos(time * 0.4);

        // Stretch in direction of movement - elongates width when moving fast
        const stretchFactor = Math.abs(movementDirection) * 0.2; // Up to 20% stretch
        const widthScale = 1 + Math.sin(time * 0.7) * 0.15 + stretchFactor; // Stretches when moving
        const heightScale = 1 + Math.cos(time * 0.9 + 0.5) * 0.12 + edgeHeightBoost - (stretchFactor * 0.3); // Squishes height when stretching width

        // Skew in direction of movement - creates that "pulling" effect
        const directionSkew = movementDirection * 15; // Skew based on direction
        const skewX = Math.sin(time * 0.6) * 8 + directionSkew; // Gentle left/right flow + directional pull
        const skewY = Math.cos(time * 0.5) * 5; // Subtle ripple effect

        // Very minimal rotation - just a hint of swirl
        const rotation = Math.sin(time * 0.3) * 3;

        // Apply transformation - slow, fluid, glass-like liquid movement
        // translateX(-50%) centers the element, then add horizontal movement on top
        glowElement.style.transform = `
            translateX(calc(-50% + ${horizontalMove}px))
            translateY(${verticalMove}px)
            scale(${widthScale}, ${heightScale})
            rotate(${rotation}deg)
            skew(${skewX}deg, ${skewY}deg)
        `;

        animationFrame = requestAnimationFrame(animateGlow);
    }

    // Start animation
    animationFrame = animateGlow();

    // Cleanup function
    return () => {
        if (animationFrame) {
            cancelAnimationFrame(animationFrame);
        }
        if (glowElement && glowElement.parentNode) {
            glowElement.parentNode.removeChild(glowElement);
        }
    };
}
